<template>
  <div class="home">
    <Row>
        <Col :xs="{ span: 24, offset: 0 }" :sm="{ span: 24, offset: 0 }" :md="{ span: 8, offset: 8 }" :lg="{ span: 8, offset: 8 }">
          <Input v-model="searchQuery" placeholder="Search.." style="width: auto">
            <Icon type="ios-search" slot="suffix" />
          </Input>
          <Button @click="search()" type="primary">Search</Button>
          <br>
          <Alert v-show="emptySubmit" type="warning" show-icon>Type something!</Alert>
        </Col>
    </Row>
    <br>
    <Progress v-show="showProgress" :percent="error !== '' ? 100 : progressPercent" :status="error !== '' ? 'wrong' : 'active'" :stroke-width="1" />
    <br>
    <Content v-if="results && (error === '')">
      <Row :gutter="5" type="flex">
        <Col :xs="24" :sm="24" :md="8" :lg="6">
               <Card style="width:320px">
                  <div style="text-align:center">
                      <img :src="results.Poster">
                  </div>
              </Card>
        </Col>
        <Col span="18" :xs="24" :sm="24" :md="16" :lg="18">
          <Card>
            <p slot="title">{{results.Title + ' (' +results.Year + ')'}}</p>
            <p>Rated: {{results.Rated}}</p>
            <p>Runtime: {{results.Runtime}}</p>
            <p>Genre: {{results.Genre}}</p>
            <p>Actors: {{results.Actors}}</p>
            <p>Plot: {{results.Plot}}</p>
            <p>Director: {{results.Director}}</p>
            <p>Language: {{results.Language}}</p>
            <p>Country: {{results.Country}}</p>
            <p>Awards: {{results.Awards}}</p>
          </Card>
        </Col>
    </Row>
    </Content>
    <Row>
        <Col span="8" offset="8">
        <Alert v-if="error" type="error" show-icon>{{error}}</Alert>
        {{!error && !searchQuery ? 'Search for a movie or tv series': ''}}
        </Col>
    </Row>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import {Row, Col, Progress, Card, Content, Input, Button, Alert, Icon} from 'iview'
import { setTimeout } from 'timers';
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Progress', Progress)
Vue.component('Card', Card)
Vue.component('Content', Content)
Vue.component('Input', Input)
Vue.component('Button', Button)
Vue.component('Alert', Alert)
Vue.component('Icon', Icon)
export default {
  name: 'home',
  data(){
    return {
      searchQuery: '',
      results: '',
      showProgress: false,
      progressPercent: 0,
      error: '',
      emptySubmit: false
    }
  },
  methods:{
    search(){
      if(this.searchQuery === ''){
        this.emptySubmit = true
        return false
      }else{
        this.emptySubmit = false
        }
      let mmi = this
      mmi.error = ''
      // Add a request interceptor
      this.axios.interceptors.request.use( (request) => {
        this.progressPercent = 20
        this.showProgress = true
        return request;
      }, function (error) {
        return Promise.reject(error);
      });
      // Add a response interceptor
      this.axios.interceptors.response.use( (response) => {
        mmi.progressPercent = 100
        setTimeout(()=>{
          mmi.showProgress = false
          mmi.progressPercent = 0
        }, 1500)
        return response;
      }, function (error) {
        return Promise.reject(error);
      });
      this.axios.get('https://www.omdbapi.com/?t='+this.searchQuery+'&apikey=706c1610', {
        // onDownloadProgress: (progressEvent) => {
        //   let totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
        //   console.log("onDownloadProgress", progressEvent.target.getResponseHeader('content-length'));
        //   if (totalLength !== null) {
        //     mmi.progressPercent = Math.round( (progressEvent.loaded * 100) / totalLength );
        //   }
        // }
      })
      .then(response => {
        if(response.data.Error){
          mmi.error = response.data.Error
          setTimeout(()=>{
            mmi.showProgress = false
            mmi.progressPercent = 0
          }, 1500)
        }else{
          mmi.results = response.data
          mmi.error = ''
        }
      })
      .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
    }
  }
}
</script>
<style>
  p{
    text-align: left;
  }
</style>
